import * as Immutable from 'immutable';
import * as React from 'react';
import { Input } from 'semantic-ui-react';

import { FormattedMessageHelper } from '../../shared/helpers/internationalization';
import { FieldSet } from '../Forms';

interface ReferrerProps {
  emailData: { value: string; valid: boolean; errors: Immutable.List<any> };
  onChangeEmail: (_: any, data: any) => void;
  onBlurEmail: (dataInfo: any) => void;
  handleSubmit: () => void;
  handleNotReferred: () => void;
  handleclose: () => void;
  title: string;
}

export const Referrer = ({ handleclose, onBlurEmail, title, emailData, onChangeEmail, handleSubmit, handleNotReferred }: ReferrerProps) => (
  <div>
    <header className={`${title ? 'modal__header' : ''}`}>{title && <h3 className="modal__title">{title}</h3>}</header>
    <div className="modal__content-text">
      <FormattedMessageHelper id="referrer.modal.text" />
    </div>
    <div className="modal__content-form">
      <FieldSet id="referrer" label="account.referrer" errors={emailData.errors}>
        <Input
          id="referrer"
          type="text"
          name="referrer"
          value={emailData.value}
          tabIndex={1}
          onBlur={onBlurEmail}
          onChange={onChangeEmail}
          className="form__input"
        />
      </FieldSet>
    </div>
    <div className="modal__section--buttons modal__section--buttons--right">
      <button onClick={handleNotReferred} className="button  button--secondary">
        <FormattedMessageHelper id="referrer.modal.btn.not.referred" />
        &nbsp;
      </button>
      <button onClick={handleSubmit} disabled={!emailData.valid} className="button  button--primary">
        <FormattedMessageHelper id="app.submit" />
        &nbsp;
      </button>
    </div>
  </div>
);
